export default "__VITE_PUBLIC_ASSET__278a39fc__"